import React, { useState } from 'react'
import { useAuth } from '../../context/AuthContext'
import { useTheme } from '../../context/ThemeContext'
import { Moon, Sun } from 'lucide-react'
import toast from 'react-hot-toast'

const Settings = () => {
  const { profile } = useAuth()
  const { isDark, toggleTheme } = useTheme()
  const [password, setPassword] = useState({ current: '', new: '', confirm: '' })

  const handlePasswordChange = (e) => {
    e.preventDefault()
    toast.info('Password change coming soon!')
  }

  return (
    <div className="max-w-2xl mx-auto space-y-6">
      <h1 className="text-2xl font-bold">Settings</h1>
      
      <div className="card">
        <h2 className="text-lg font-semibold mb-4">Theme</h2>
        <button onClick={toggleTheme} className="btn btn-outline">
          {isDark ? <Sun className="w-5 h-5" /> : <Moon className="w-5 h-5" />}
          Switch to {isDark ? 'Light' : 'Dark'} Mode
        </button>
      </div>

      <div className="card">
        <h2 className="text-lg font-semibold mb-4">Change Password</h2>
        <form onSubmit={handlePasswordChange} className="space-y-4">
          <div className="input-group">
            <label>Current Password</label>
            <input type="password" value={password.current} onChange={e => setPassword({...password, current: e.target.value})} />
          </div>
          <div className="input-group">
            <label>New Password</label>
            <input type="password" value={password.new} onChange={e => setPassword({...password, new: e.target.value})} />
          </div>
          <div className="input-group">
            <label>Confirm New Password</label>
            <input type="password" value={password.confirm} onChange={e => setPassword({...password, confirm: e.target.value})} />
          </div>
          <button type="submit" className="btn btn-primary">Update Password</button>
        </form>
      </div>
    </div>
  )
}

export default Settings